import { QuestionBase } from './question-base';

/*

Sample:

new TextboxQuestion({
  key: 'name',
  label: 'nouns.name',
  // value: 'Peter',
  required: true,
  order: 1
}),

*/
export class TextboxQuestion extends QuestionBase<string> {
  controlType = 'textbox';
  type: string;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || 'text';
  }
}
